import React from 'react'
import Store from '../../store/store'
import HeaderSteps from './headersteps'
import Upload from './steps/upload'
import Assignment from './steps/assignment'
import Download from './steps/Download'
import api from '../../source/api'
import BaseComponent from '../base'
import SupplierRules from './SupplierRules'
import {Link} from "react-router-dom";
import NotificationSystem from "react-notification-system";
import RuleUpdateModal from "./Rules/RuleUpdateModal";

class Supplier extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            company: null,
            config: null,
            currentStep: 1,

            onlineszamlaToken: false,
            showRulesPage: false,
            editRule: null,

            invoices: [],
            supplierRules: [],
            vatCollectorCodes: [],
            partners: [],
        };
        this.store = Store;
    };

    notifySuccess = (message) => {
        this.refs.notificationSystem.addNotification({
            message: message,
            level: 'success',
            position: 'tc',
            autoDismiss: 10
        })
    };

    notifyError = (message) => {
        this.refs.notificationSystem.addNotification({
            message: message,
            level: 'error',
            position: 'tc',
            autoDismiss: 10
        })
    };

    componentDidMount = () => {
        window.scrollTo(0, 0);
        api.get('supplier/' + this.props.location.match.params.id + '/init')
            .then((response) => {
                this.setState({
                    company: response.data.company,
                    config: response.data.config,
                    vatCollectorCodes: response.data.vatCollectorCodes,
                    supplierRules: response.data.supplierRules,
                    onlineszamlaToken: response.data.onlineszamlaToken
                });
            })
    };

    setStep = (step) => {
        this.setState({
            currentStep: step
        });
    };

    nextStep = () => {
        this.setStep(this.state.currentStep + 1);
    };

    toggleRulesPage = () => {
        this.setState({
            showRulesPage: !this.state.showRulesPage
        });
    };

    setData = (data) => {
        this.setState(data);
    };

    updateRules = (supplierRules) => {
        this.updateInvoices(this.state.invoices, supplierRules)
    }

    updatePartners = (partners) => {
        this.setState({partners: partners})
    }

    updateInvoices = (invoices, supplierRules) => {
        let self = this;
        let addRuleCount = 0;
        let removeRuleCount = 0;

        invoices.map(function (invoice) {
            invoice.items.map(function (invoiceItem) {
                let selectedRule = self.invoiceFindRule(invoice, invoiceItem, supplierRules);

                if (selectedRule) {
                    invoiceItem.main_bookkeeping_number = selectedRule.main_bookkeeping_number;
                    invoiceItem.vat_collector_id = selectedRule.vat_collector_id;
                    invoiceItem.vat_collector_title = selectedRule.vat_collector_id ? self.state.vatCollectorCodes.find(x => x.id === selectedRule.vat_collector_id).title : '';
                    invoiceItem.vat_degree = selectedRule.vat_degree;

                    if (invoiceItem.rule_id !== selectedRule.id) {
                        invoiceItem.rule_id = selectedRule.id;
                        addRuleCount++;
                    }
                } else if (invoiceItem.rule_id) {
                    invoiceItem.rule_id = null;
                    invoiceItem.main_bookkeeping_number = null;
                    invoiceItem.vat_collector_id = null;
                    invoiceItem.vat_collector_title = null;
                    invoiceItem.vat_degree = null;
                    removeRuleCount++;
                }
            });
        });

        if (addRuleCount > 0) {
            this.notifySuccess(addRuleCount + ' darab sor sikeresen kontírozva.');
        }

        this.setState({
            invoices: invoices,
            supplierRules: supplierRules,
        })
    };

    invoiceFindRule(invoice, invoiceItem, supplierRules) {
        for (let ruleIndex in supplierRules) {
            if (this.invoiceCheckRule(invoice, invoiceItem, supplierRules[ruleIndex])) {
                return supplierRules[ruleIndex];

            }
        }
        return null;
    }

    invoiceCheckRule(invoice, invoiceItem, rule) {
        if (rule.supplier_name
            && invoice.supplier.name.toUpperCase() !== rule.supplier_name.toUpperCase()
        ) {
            return false;
        }
        if (rule.item_name
            && !invoiceItem.name.toUpperCase().includes(rule.item_name.toUpperCase())
        ) {
            return false;
        }
        if (rule.vat * 1 !== invoiceItem.vatPercentage * 100) {
            return false;
        }
        return true;
    }

    updateConfig = (config) => {
        this.setState({config: config});
    }

    editRule = (rule) => {
        this.setState({editRule: rule});
    }

    render() {
        if (!this.state.company) {
            return <section id='supplier-upload'>
                <NotificationSystem ref='notificationSystem'/>
            </section>;
        }

        return (
            <section id='supplier-upload'>
                {this.state.showRulesPage
                    ? <SupplierRules
                        config={this.state.config}
                        supplierRules={this.state.supplierRules}
                        vatCollectorCodes={this.state.vatCollectorCodes}

                        toggleRulesPage={() => this.toggleRulesPage()}
                        updateRules={(supplierRules) => this.updateRules(supplierRules)}
                        editRule={(rule) => this.editRule(rule)}
                        notifySuccess={(msg) => this.notifySuccess(msg)}
                        notifyError={(msg) => this.notifyError(msg)}
                    />
                    : <div>
                        <HeaderSteps setStep={(step) => this.setStep(step)} currentStep={this.state.currentStep}/>
                        <div className='header'>
                            <div className='container'>

                                <h1 className='margin-bottom-50'>Onlineszamla rendszerből lekért tételek kontírozása és könyvelése.</h1>

                                <p>
                                    Kérjük állítsa be az Online számla API kapcsolatát a bejövő számlákhoz,
                                    majd adja meg a kiválasztott cég főkönyvi struktúrájának megfelelő Főkönyvi számokat és állítsa be a könyvelni kívánt időszakot.
                                </p>

                                <div className="row" style={{marginBottom: "50px"}}>
                                    <div className="col-md-12">
                                        <div className="pull-left">
                                            <h4 className='text-left'>Kiválasztott cég: {this.state.company ? this.state.company.name : ''} (<Link to='/' className='link-color'>cég csere</Link>)</h4>
                                        </div>
                                        <div className="pull-right">
                                            {this.state.company
                                                ? <Link className={this.state.company.onlineszamlaToken ? 'table-green-btn' : 'table-gray-btn'} to={`/company/onlineszamla/${this.state.company.id}`}>Onlineszámla API</Link>
                                                : null
                                            }&nbsp;
                                            <a onClick={() => this.toggleRulesPage()} className='table-green-btn'>Szabályok</a>&nbsp;
                                            <a href='/letoltesek/Beeker_Onlineszamla.pdf' className='table-green-btn' target='_blank'>Használati útmutató</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="upload-body">
                            {this.state.currentStep === 1
                                ? <div className='container'>
                                    <div className='row'>
                                        <div className='col-md-10 offset-md-1'>
                                            <Upload
                                                config={this.state.config}
                                                vatCollectorCodes={this.state.vatCollectorCodes}
                                                userconfigs={this.state.userconfigs}
                                                supplierRules={this.state.supplierRules}
                                                invoices={this.state.invoices}
                                                updateInvoices={(invoices, supplierRules) => this.updateInvoices(invoices, supplierRules)}
                                                updatePartners={(partners) => this.updatePartners(partners)}
                                                updateConfig={(config) => this.updateConfig(config)}
                                                nextStep={() => this.nextStep()}
                                                notifySuccess={(msg) => this.notifySuccess(msg)}
                                                notifyError={(msg) => this.notifyError(msg)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                : null}
                            {this.state.currentStep === 2
                                ? <Assignment
                                    config={this.state.config}
                                    vatCollectorCodes={this.state.vatCollectorCodes}
                                    invoices={this.state.invoices}
                                    supplierRules={this.state.supplierRules}
                                    nextStep={() => this.nextStep()}
                                    setData={(data) => this.setData(data)}
                                    updateInvoices={(invoices, supplierRules) => this.updateInvoices(invoices, supplierRules)}
                                    updateRules={(supplierRules) => this.updateRules(supplierRules)}
                                    notifySuccess={(msg) => this.notifySuccess(msg)}
                                    notifyError={(msg) => this.notifyError(msg)}
                                />
                                : null}
                            {this.state.currentStep === 3
                                ? <Download
                                    config={this.state.config}
                                    invoices={this.state.invoices}
                                    partners={this.state.partners}
                                    notifySuccess={(msg) => this.notifySuccess(msg)}
                                    notifyError={(msg) => this.notifyError(msg)}
                                />
                                : null
                            }
                        </div>
                    </div>
                }
                {this.state.editRule
                    ? <RuleUpdateModal
                        config={this.state.config}
                        rule={this.state.editRule}
                        vatCollectorCodes={this.state.vatCollectorCodes}

                        editRule={(rule) => this.editRule(rule)}
                        updateRules={(supplierRules) => this.updateRules(supplierRules)}
                        notifySuccess={(msg) => this.notifySuccess(msg)}
                        notifyError={(msg) => this.notifyError(msg)}
                    />
                    : null
                }
                <NotificationSystem ref='notificationSystem'/>
            </section>
        )
    }
}

export default Supplier


// WEBPACK FOOTER //
// ./src/components/supplier/supplier.js